import styled from 'styled-components';

export const Root = styled.a`
  display: block;
  border-radius: ${({ theme }) => theme.radiusSm};
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontFamily};
  background: ${({ theme }) => theme.colors.card};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadowCard};
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.2s, border-color 0.2s;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadowCardHover};
    border-color: rgba(0, 48, 135, 0.12);
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 11.5rem;
  object-fit: cover;
  display: block;
`;

export const Body = styled.div`
  padding: 1.25rem 1.35rem 1.35rem;
`;

export const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.65rem;
`;

export const Sponsored = styled.span`
  padding: 0.2rem 0.55rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 14px);
  background: rgba(234, 179, 8, 0.18);
  color: ${({ theme }) => theme.colors.goldForeground};
  font-size: ${({ theme }) => theme.fontClamp.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const Sponsor = styled.span`
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: ${({ theme }) => theme.colors.mutedForeground};
`;

export const H = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.fontClamp.lg};
  font-weight: 700;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.foreground};
`;

export const Desc = styled.p`
  margin: 0.45rem 0 0;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  line-height: 1.55;
  color: ${({ theme }) => theme.colors.mutedForeground};
`;

export const Cta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.9rem;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
`;
